const LAYERS = [
  { name: "Checkout / Mobile", depth: 0, active: true },
  { name: "Header", depth: 1 },
  { name: "Cart summary", depth: 1 },
  { name: "Pay button", depth: 1, selected: true },
  { name: "Checkout / Desktop", depth: 0 },
  { name: "Sidebar", depth: 1 },
];

const PROPS = [
  { label: "Fill", value: "#C8F04D", swatch: "#c8f04d" },
  { label: "Radius", value: "12" },
  { label: "Auto layout", value: "16 · 12" },
  { label: "Text", value: "Sora 14 / 20" },
  { label: "Ink", value: "#1C242C", swatch: "#1c242c" },
];

export function createUiUxDesignStage() {
  const wrap = document.createElement("div");
  wrap.className = "services-stage services-stage--design reveal";
  wrap.style.setProperty("--delay", "0.18s");
  wrap.setAttribute("aria-hidden", "true");

  wrap.innerHTML = `
    <div class="services-stage__glow"></div>
    <div class="services-stage__orb services-stage__orb--a"></div>
    <div class="services-stage__orb services-stage__orb--b"></div>
    <div class="services-stage__orb services-stage__orb--c"></div>

    <div class="services-stage__window services-stage__panel">
      <div class="services-stage__chrome">
        <span class="services-stage__dot services-stage__dot--r"></span>
        <span class="services-stage__dot services-stage__dot--y"></span>
        <span class="services-stage__dot services-stage__dot--g"></span>
        <span class="services-stage__path">design.canvas / checkout-flow</span>
        <span class="services-stage__live"><span></span>3 editing</span>
      </div>

      <div class="canvas-stage">
        <aside class="canvas-stage__panel canvas-stage__layers">
          <span class="canvas-stage__eyebrow">Layers</span>
          <ul>
            ${LAYERS.map(
              (l) => `
              <li class="${l.selected ? "is-selected" : ""}${l.active ? " is-frame" : ""}" style="--depth: ${l.depth}">
                <i></i>${l.name}
              </li>
            `
            ).join("")}
          </ul>
        </aside>

        <div class="canvas-stage__board">
          <div class="canvas-stage__frame canvas-stage__frame--mobile">
            <span class="canvas-stage__frame-label">Checkout / Mobile</span>
            <div class="canvas-stage__bar"></div>
            <div class="canvas-stage__image"></div>
            <div class="canvas-stage__line canvas-stage__line--w70"></div>
            <div class="canvas-stage__line canvas-stage__line--w45"></div>
            <div class="canvas-stage__row">
              <div class="canvas-stage__line canvas-stage__line--w40"></div>
              <div class="canvas-stage__line canvas-stage__line--w20 canvas-stage__line--ink"></div>
            </div>
            <div class="canvas-stage__button" data-selected>
              Pay $128.00
              <b class="canvas-stage__handle canvas-stage__handle--tl"></b>
              <b class="canvas-stage__handle canvas-stage__handle--tr"></b>
              <b class="canvas-stage__handle canvas-stage__handle--bl"></b>
              <b class="canvas-stage__handle canvas-stage__handle--br"></b>
              <span class="canvas-stage__measure">328 × 44</span>
            </div>
          </div>

          <div class="canvas-stage__frame canvas-stage__frame--desktop">
            <span class="canvas-stage__frame-label">Checkout / Desktop</span>
            <div class="canvas-stage__bar"></div>
            <div class="canvas-stage__cols">
              <div>
                <div class="canvas-stage__line canvas-stage__line--w80"></div>
                <div class="canvas-stage__line canvas-stage__line--w60"></div>
                <div class="canvas-stage__line canvas-stage__line--w70"></div>
                <div class="canvas-stage__line canvas-stage__line--w50"></div>
              </div>
              <div class="canvas-stage__card">
                <div class="canvas-stage__line canvas-stage__line--w60"></div>
                <div class="canvas-stage__line canvas-stage__line--w40"></div>
                <div class="canvas-stage__button canvas-stage__button--sm">Pay</div>
              </div>
            </div>
          </div>

          <span class="canvas-stage__cursor canvas-stage__cursor--a"><i></i><b>Sara</b></span>
          <span class="canvas-stage__cursor canvas-stage__cursor--b"><i></i><b>Omar</b></span>
        </div>

        <aside class="canvas-stage__panel canvas-stage__props">
          <span class="canvas-stage__eyebrow">Design</span>
          ${PROPS.map(
            (p) => `
            <div class="canvas-stage__prop">
              <span>${p.label}</span>
              <strong>${p.swatch ? `<b style="--swatch: ${p.swatch}"></b>` : ""}${p.value}</strong>
            </div>
          `
          ).join("")}
          <span class="canvas-stage__eyebrow canvas-stage__eyebrow--gap">Tokens</span>
          <div class="canvas-stage__tokens">
            <i style="--swatch: #c8f04d"></i><i style="--swatch: #1c242c"></i><i style="--swatch: #344555"></i><i style="--swatch: #8a96a3"></i><i style="--swatch: #e0e7ee"></i>
          </div>
        </aside>
      </div>

      <div class="services-stage__footer">
        <span>Design system</span>
        <span>Dev handoff</span>
        <span class="services-stage__pulse">syncing tokens</span>
      </div>
    </div>
  `;

  return wrap;
}
